// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"30e0612f","139":"0851f2ec"}[chunkId] + ".chunk.js";
};